// extracted by mini-css-extract-plugin
export default {"layout":"styles_layout__fyleu","article":"styles_article__JFIsD","title":"styles_title__HoGFk","description":"styles_description__MQXtM"};